export const LEADERBORARD_RECEIVED = "LEADERBORARD_RECEIVED";
